import { pickBy, isEmpty, isNil, isInteger } from 'lodash'
import { bus, EVENTS } from '@/services/bus/index.js'
import axios from 'axios'
import Vue from 'vue'
import moment from 'moment'

let vue = new Vue()

export function downloadURI (uri, name) {
  bus.$emit(EVENTS.LOAD_DOCUMENT)
  axios({
    url: uri,
    method: 'GET',
    responseType: 'blob'
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.download = name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    bus.$emit(EVENTS.DOCUMENT_LOADED)
  }).catch(() => {
    bus.$emit(EVENTS.DOCUMENT_LOADED)
  })
}

export function exportXls (url, query, isArray = false, name) {
  let cleanedQuery
  if (isArray) cleanedQuery = cleanQueryArray(query)
  else cleanedQuery = cleanQuery(query)
  const apiUrl = vue.$configs.APIURL
  const token = `token=${vue.$api.token}`
  const exportURl = `${apiUrl}/${url}?${token}&${cleanedQuery}`
  downloadURI(exportURl, `${name || url}.xlsx`)
}

export function exportXlsNote (url, name) {
  const apiUrl = vue.$configs.APIURL
  const exportURl = `${apiUrl}/${url}`
  downloadURI(exportURl, `${name || url}.xlsx`)
}

export function exportXlsFromMultiselect ({ url, query }) {
  const apiUrl = vue.$configs.APIURL
  const token = `token=${vue.$api.token}`
  const exportURl = `${apiUrl}/${url}?${token}&${query}`
  downloadURI(exportURl, `${url}.xlsx`)
}

export function stringToBool (string) {
  switch (string.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true
    case 'false':
    case 'no':
    case '0':
    case null:
      return false
    default:
      return Boolean(string)
  }
}

export function cleanQuery (val) {
  val = pickBy(val, x => {
    if (isInteger(x)) return true
    else if (isEmpty(x) || isNil(x)) return false
    else return true
  })
  return Object.keys(val).map(key => {
    if (Array.isArray(val[key]) && val[key].length) {
      return val[key].map(x => key + '=' + x).join('&')
    } else {
      return key + '=' + val[key]
    }
  }).join('&')
}

export function cleanQueryArray (val) {
  val = pickBy(val, x => {
    if (isInteger(x)) return true
    else if (isEmpty(x) || isNil(x)) return false
    else return true
  })
  return Object.keys(val).map(key => {
    if (Array.isArray(val[key]) && val[key].length) {
      return val[key].map(x => key + '[]=' + x).join('&')
    } else {
      return key + '=' + val[key]
    }
  }).join('&')
}

export function moveInArray (arr, oldIndex, newIndex) {
  while (oldIndex < 0) {
    oldIndex += arr.length
  }
  while (newIndex < 0) {
    newIndex += arr.length
  }
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length
    while ((k--) + 1) {
      arr.push(undefined)
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
  return arr
}

export function googleEventToRdv (event) {
  let date
  let endDate
  if (event.start && event.start.dateTime) {
    date = moment(event.start.dateTime)
  } else {
    date = moment(event.start.date, 'YYYY-MM-DD')
  }
  if (event.end && event.end.dateTime) {
    endDate = moment(event.end.dateTime)
  } else {
    endDate = moment(event.end.date, 'YYYY-MM-DD')
  }
  if (!endDate) {
    endDate = moment(date).add(2, 'h')
  }
  let rdv = {
    date: date.utc().format('DD/MM/YYYY HH:mm'),
    end_date: endDate.utc().format('DD/MM/YYYY HH:mm'),
    note: event.description
  }
  return rdv
}

export function rdvToGoogleEvent (rdv, host) {
  let event
  let location = []
  if (rdv.address && rdv.address.zip_code && rdv.address.city) {
    if (rdv.address.line1) {
      location.push(rdv.address.line1)
    }
    location.push(rdv.address.zip_code)
    location.push(rdv.address.city)
  }
  location = location.join(' ')
  let attendees = []
  if (rdv.guests_email) {
    attendees = rdv.guests_email.map(x => {
      return {
        email: x
      }
    })
  }

  // let eventData = Object.assign({}, rdv)
  let rdvType = rdv.rdv_type
  let contactName = rdv.contact_name
  let date = moment(rdv.date).toDate()
  let endDate = moment(rdv.end_date).toDate()
  let summary = `${rdvType} avec ${contactName}`
  event = {
    summary: summary,
    description: rdv.note,
    start: {
      dateTime: date.toISOString(),
      timezone: 'Europe/Paris'
    },
    end: {
      dateTime: endDate.toISOString(),
      timezone: 'Europe/Paris'
    },
    reminders: {
      useDefault: true
    },
    source: {
      title: host,
      url: host
    },
    location: location,
    extendedProperties: {
      private: {
        rdvPk: rdv.pk,
        sellerPk: rdv.seller,
        contactPk: rdv.contact
      }
    },
    attendees: attendees
  }

  return event
}



// WEBPACK FOOTER //
// ./src/utils/index.js